import PercentGauge from '../../percent-gauge';
import BvIcon from 'volta/components/bv-icon';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellPlanningPriorityCellInnerSignature {
  Args: {
    value: unknown;
  };
}

const CellPlanningPriorityCellInnerComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class='planning-priority-cell__inner'>
    <PercentGauge
      @criticality={{@value.priorityName}}
      @level={{@value.bufferPenetration}}
      @displayEmptyText={{@value.displayEmptyText}}
      @emptyTextLabel={{@value.emptyTextLabel}}
      @fullWidth={{true}}
      @bordered={{true}}
    />
    <BvIcon
      class='planning-priority-cell__spike'
      @glyph={{if @value.hasDemandSpike 'flash' 'blank'}}
      @color='orange'
      @size='sm'
    />
  </div>
</template> satisfies TemplateOnlyComponent<CellPlanningPriorityCellInnerSignature>;

export default CellPlanningPriorityCellInnerComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::PlanningPriorityCell::Inner': typeof CellPlanningPriorityCellInnerComponent;
    'cell/planning-priority-cell/inner': typeof CellPlanningPriorityCellInnerComponent;
  }
}
